import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { entries } from '@debbie/common/dist/util';
import DateInput from '../DateInput';
import Input from '../Input';
import MoneyInput from '../MoneyInput';
import Select from '../Select';
export const DateRangeFilter = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(DateInput, { allowNull: true, value: props.from ? moment(props.from) : null, onChange: (x) => {
                if (x) {
                    const d = x.toDate();
                    props.onChange(d.toISOString(), props.to);
                }
                else {
                    props.onChange(x, props.to);
                }
            }, placeholder: lang.table.from }),
        React.createElement(DateInput, { allowNull: true, value: props.to ? moment(props.to) : null, onChange: (x) => {
                if (x) {
                    const d = x.toDate();
                    props.onChange(props.from, d.toISOString());
                }
                else {
                    props.onChange(props.from, x);
                }
            }, placeholder: lang.table.to })));
};
export const NumberRangeFilter = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Input, { type: "number", placeholder: lang.table.from, value: (_a = props.from) !== null && _a !== void 0 ? _a : undefined, onChange: (e) => {
                const parsedNum = parseInt(e.currentTarget.value);
                if (isNaN(parsedNum)) {
                    props.onChange(null, props.to);
                    return;
                }
                props.onChange(parsedNum, props.to);
            } }),
        React.createElement(Input, { type: "number", placeholder: lang.table.to, value: (_b = props.to) !== null && _b !== void 0 ? _b : undefined, onChange: (e) => {
                const parsedNum = parseInt(e.currentTarget.value);
                if (isNaN(parsedNum)) {
                    props.onChange(props.from, null);
                    return;
                }
                props.onChange(props.from, parsedNum);
            } })));
};
export const SearchFilter = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Input, { type: "text", onChange: (e) => {
                if (e.currentTarget.value != null &&
                    e.currentTarget.value.length > 0) {
                    props.onChange(e.currentTarget.value);
                }
                else {
                    props.onChange(null);
                }
            }, placeholder: lang.table.search, value: (_a = props.query) !== null && _a !== void 0 ? _a : '' })));
};
export const MoneyRangeFilter = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(MoneyInput, { allowNull: true, value: props.from, placeholder: lang.table.from, onChange: (x) => {
                props.onChange(x, props.to);
            } }),
        React.createElement(MoneyInput, { allowNull: true, value: props.to, placeholder: lang.table.to, onChange: (x) => {
                props.onChange(props.from, x);
            } })));
};
export const CategoryFilter = (props) => {
    return (React.createElement("div", null, entries(props.categories).map(([key, val]) => {
        if (val == null) {
            return null;
        }
        return (React.createElement("div", { key: key, style: { padding: '0.5em' } },
            React.createElement("label", null,
                React.createElement("input", { style: { marginRight: '0.5em' }, type: "checkbox", name: key, checked: props.selected.includes(key), onChange: () => {
                        if (props.selected.includes(key)) {
                            props.onChange(props.selected.filter((s) => s != key));
                        }
                        else {
                            props.onChange([...props.selected, key]);
                        }
                    } }),
                val.label)));
    })));
};
export const BooleanFilter = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Select, { value: (_a = props.filter.showTrue) !== null && _a !== void 0 ? _a : 'all', onChange: (e) => {
                const value = e.currentTarget.value;
                if (value == 'all') {
                    props.onChange({
                        showTrue: undefined,
                    });
                }
                else if (value === 'true') {
                    props.onChange({
                        showTrue: true,
                    });
                }
                else if (value === 'false') {
                    props.onChange({
                        showTrue: false,
                    });
                }
            } },
            React.createElement("option", { value: 'all' }, lang.misc.all),
            React.createElement("option", { value: 'true' }, lang.misc.yes),
            React.createElement("option", { value: 'false' }, lang.misc.no))));
};
//# sourceMappingURL=Filters.js.map